// extracted by mini-css-extract-plugin
module.exports = {"body":"ManagementProfile_body__1JZPQ","column1":"ManagementProfile_column1__2VLFj","column1Modal":"ManagementProfile_column1Modal__jYDQO"};